import ReactGA from 'react-ga4';

// Google Analytics Measurement ID
const MEASUREMENT_ID = 'G-0KRTN3EY4Y';

/**
 * Initialize Google Analytics
 * @param options Additional initialization options
 */
export const initializeGA = (options = {}) => {
  // Only initialize in production or if explicitly enabled in development
  if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_GA === 'true') {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        // Additional configuration options can be added here
      },
      ...options,
    });
    console.log('Google Analytics initialized');
  } else {
    console.log('Google Analytics not initialized in development mode');
  }
};

/**
 * Track page view
 * @param path Current page path
 * @param title Page title
 */
export const trackPageView = (path: string, title?: string) => {
  if (path) {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title || document.title,
    });
  }
};

/**
 * Track user event
 * @param category Event category
 * @param action Event action
 * @param label Event label (optional)
 * @param value Event value (optional)
 */
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

/**
 * Track user exception/error
 * @param description Error description
 * @param fatal Whether the error was fatal
 */
export const trackException = (description: string, fatal = false) => {
  // In react-ga4, we use event to track exceptions instead of the exception method
  ReactGA.event({
    category: 'Error',
    action: description,
    label: fatal ? 'Fatal Error' : 'Non-Fatal Error',
    nonInteraction: true,
  });
};

/**
 * Set user ID for tracking
 * @param userId User identifier
 */
export const setUserId = (userId: string) => {
  if (userId) {
    ReactGA.set({ userId });
  }
};
